import { Inject, Injectable } from '@angular/core';
import { IUnitOfWork } from 'src/app/common/contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { DeviceDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { DeviceDto } from 'src/app/shared/models/device/device-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class DeviceWorkItem extends WorkItem<DeviceDto> {
  unitOfWork: IUnitOfWork;

  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'DeviceWorkItem';
  }
  get database(): string {
    return DeviceDB;
  }

  get chunkSize(): number {
    return 75;
  }
}
